<template>
  <GfrNewButton class="app-docs-obsolete group" :data-state="model ? 'open' : 'close'" @click="() => (model = !model)">
    <IconsSight
      class="h-5.5 w-5.5 transition-colors duration-200 group-data-[state=close]:hidden max-lg:h-10 max-lg:w-10"
    />
    <IconsCloseSight
      class="mt-px h-5.5 w-5.5 transition-colors duration-200 group-data-[state=open]:hidden max-lg:h-10 max-lg:w-10"
    />
  </GfrNewButton>
</template>
<script lang="ts" setup>
const model = defineModel({ type: Boolean })
</script>
<style scoped lang="scss">
.app-docs-obsolete {
  @apply flex h-10 w-10 items-center justify-center border border-[#4D5158] bg-[#363A41] text-[#7A7E85] lg:hover:text-white;
  @apply max-lg:h-18 max-lg:w-18;
}
</style>
